import TPBPageContent from './TPBPageContent.component';

export default TPBPageContent;
